import {
  createContext,
  type PropsWithChildren,
  useContext,
  useMemo,
  useRef
} from "react"
import { useMatches } from "react-router-dom"

import type { PageBuilderRoute } from "./routes"

export function RouteStateProvider(props: PropsWithChildren) {
  const { children } = props

  const matches = useMatches()
  const lastDocListHrefRef = useRef<string>()

  // matches[0] is the root route: Ignore.
  const routeId = matches[1]?.id

  if (routeId && docListRoutes.has(routeId)) {
    lastDocListHrefRef.current = location.href
  }

  const lastDocListHref = lastDocListHrefRef.current

  const value = useMemo(() => ({ lastDocListHref }), [lastDocListHref])

  return (
    <RouteStateContext.Provider value={value}>
      {children}
    </RouteStateContext.Provider>
  )
}

export function useRouteState() {
  return useContext(RouteStateContext)
}

// The list of all routes showing a list of documents with links to the Document Editor.
const docListRoutes: Set<string> = new Set<PageBuilderRoute["id"]>([
  "working",
  "archived",
  "migration",
  "upcoming",
  "upcoming-detail"
])

interface RouteStateContextValue {
  lastDocListHref?: string
}

const RouteStateContext = createContext<RouteStateContextValue>({})
